import { css } from '~/lib/bn-lit-element';

export const bannerStyles = css`
.banner {
  padding: 8px;
  margin: 10px 0px;
  border-radius: 2px;
}

.banner--success {
  background-color: var(--green-10);
  color: var(--green-30);
}

.banner--info {
  background-color: var(--blue-10);
  color: var(--blue-50);
}

.banner--cold {
  background-color: var(--teal-10);
  color: var(--teal-20);
}

.banner--warning {
  background-color: var(--yellow-10);
  color: var(--yellow-30);
}

.banner--critical {
  background-color: var(--red-10);
  color: var(--red-30);
}

.banner--button--success {
  background-color: transparent;
  color: var(--green-20);
  border: 1px solid transparent;
  &:hover:enabled {
    color: var(--green-30);
  }
  &:active:enabled {
    background-color: var(green-20);
    color: var(--green-30);
  }
  &:focus:enabled {
    border-color: var(green-30);
  }
}

.banner--button--info {
  background-color: transparent;
  color: var(--blue-40);
  border: 1px solid transparent;
  &:hover:enabled {
    background-color: var(blue-10);
    color: var(--blue-60);
  }
  &:active:enabled {
    background-color: var(blue-20);
    color: var(--blue-60);
  }
  &:focus:enabled {
    border-color: var(blue-60);
  }
}
  
.banner--button--warning {
  background-color: transparent;
  color: var(--yellow-20);
  border: 1px solid transparent;
  &:hover:enabled {
    background-color: var(yellow-10);
    color: var(--yellow-30);
  }
  &:active:enabled {
    background-color: var(yellow-10);
    color: var(--yellow-30);
  }
  &:focus:enabled {
    border-color: var(yellow-30);
  }
}

.banner--button--critical {
  background-color: transparent;
  color: var(--red-20);
  border: 1px solid transparent;
  &:hover:enabled {
    background-color: var(red-10);
    color: var(--red-30);
  }
  &:active:enabled {
    background-color: var(red-20);
    color: var(--red-30);
  }
  &:focus:enabled {
    border-color: var(red-30);
  }
}
`;

export default bannerStyles.toString();
